const $eelInformation = $('.js-eel-information');

const eelInformation = {
  initialize() {
    if ($eelInformation.length) {
      this.createEvents();
    }
  },

  createEvents() {
    $eelInformation.on('click', '.js-eel-information-toggler', (e) => {
      const $el = $(e.currentTarget);
      const $toggler = $eelInformation.find('.js-eel-information-toggler');

      $toggler.removeClass('is-open');
      $el.toggleClass('is-open');
    });
  },
};

export default eelInformation;
